module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-app"
  }, [_c('div', {
    staticClass: "l-app__center"
  }, [_c('div', {
    staticClass: "c-message"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "c-message__title"
  }, [_vm._v("OOPS!")]), _vm._v(" "), _c('p', {
    staticClass: "c-message__content"
  }, [_vm._v("\n        Desculpa! A página que você está procurando não existe.\n      ")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn--lg btn--smart btn--primary",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Ir para home")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-message__media"
  }, [_c('h1', {
    staticClass: "u-fs-128"
  }, [_vm._v("404")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2580789e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Error/NotFound.vue
// module id = 2991
// module chunks = 0